'use client';

// base
import React from 'react';
import Image from 'next/image';

// styles
import { StyledFooter } from './style';

// constants
import { ciImage } from 'constants/images';

export const MainFooter: React.FC = () => {
  return (
    <StyledFooter>
      <Image src={ciImage.gsilLogoNormal} alt="gsil_icon" width={77} height={25} />
      <p className="copylight">COPYRIGHT © 2025 BY GSIL Co., Ltd. All rights reserved.</p>
    </StyledFooter>
  );
};
